import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

//const semc = process.env.VUE_APP_SEMC ? '&autocomplete.config=' + process.env.VUE_APP_SEMC : '';
//const semc = '&autocomplete.config=autocomplete.grouped'
const semc = ''
//const search_semc = '&_semc=graph';
//const search_semc ='';

export default new Vuex.Store({
  state: {
    response: '',
    action: '',
    suggest: '',
    error: '',
    graph: '',
    pureGraph: '',
    mlt: '',
    preserveFilters: false,
    showSemanticGraph: false,
    lastSearches: '',
    visitedTopics: '',
    graphSettings: {
      rows: 20,
      showNodeLabels: true,
      showLinkLabels: false,
      force: 1000
    },
    authenticated: '',
    account: '',
    researchProfiles: [],
    savedSearches: '',
    expiredTrial: false,
    isTrial: false,
    horizonTreemap: '',
    horizonCalendar: '',
    horizonBubbles: '',
    selectedResult: '',
    pendingRequests: 0,
    showFetchProfileScreen: false,
    showFetchPublicationInfo: false,
  },
  mutations: {
    increasePendingRequests(state) {
      state.pendingRequests++;
    },
    decreasePendingRequests(state) {
      if(state.pendingRequests > 0) {
        state.pendingRequests--;
      }
    },
    resetPendingRequests(state) {
      state.pendingRequests = 0;
    },
    updateAccount (state, data) {
      state.account = data;
    },
    updateResearchProfiles (state, data) {
      state.researchProfiles = data;
    },
    updateExpiredTrial(state, data) {
      if( data && data.organization && data.organization.name == "TRIAL") {
        var creationDate = new Date(data.createdDate);
        var targetDate= new Date();
        // Trial lasts 10 days
        targetDate.setDate(targetDate.getDate() - 10);
        state.expiredTrial = (creationDate < targetDate);
      } else {
        state.expiredTrial = false;
      }
      localStorage.setItem("expiredTrial", state.expiredTrial);
    },
    updateIsTrial(state, data) {
      if( data && data.organization && data.organization.name == "TRIAL") {
        state.isTrial = true;
      } else {
        state.isTrial = false;
      }
      localStorage.setItem("isTrial", state.isTrial);
    },
    updateSavedSearches (state, data) {
      state.savedSearches = data;
    },
    updateSearchResponse (state, data) {
      state.response = data;
    },
    resetResultList (state) {
      if( state.response && state.response.response && state.response.response.docs )
      state.response.response.docs = '';
    },
    updateSuggest (state, data) {
      state.suggest = data;
    },
    updateMLT (state, data) {
      state.mlt = data;
    },
    updateGraph (state, data) {
        state.graph = data;
        state.pureGraph = data;
    },
    toggleSemanticGraph (state) {
      state.error = '';
      state.showSemanticGraph = !state.showSemanticGraph;
    },
    setPreserveFilters (state, data) {
      state.error = '';
      state.preserveFilters = data;
    },
    updateGraphSettings (state, data) {
      state.graphSettings = data;
    },
    updateHorizonTreemap (state, data) {
      state.horizonTreemap = data;
    },
    updateHorizonCalendar (state, data) {
      state.horizonCalendar = data;
    },
    updateHorizonBubbles (state, data) {
      state.horizonBubbles = data;
    },
    updateSelectedResult (state, data) {
      state.selectedResult = data;
    },
    updateLastSearches(state,data) {
      if( data != '' && data != '*') {
        var idx = state.lastSearches.indexOf(data);
        if(idx > -1) {
          state.lastSearches.splice(idx,1);
        }
        state.lastSearches.push(data);
        localStorage.setItem("lastSearches", JSON.stringify(state.lastSearches));
      }
    },
    deleteLastSearches(state) {
      state.lastSearches = [];
      localStorage.setItem("lastSearches", []);
    },
    updateVisitedTopics(state, data) {
      if( data != '' ) {
        state.visitedTopics.push(data);
        localStorage.setItem("visitedTopics", JSON.stringify(state.visitedTopics));
      }
    },
    deleteVisitedTopics(state) {
      state.visitedTopics = [];
      localStorage.setItem("visitedTopics", []);
    },
    initializeStorage(state) {
      if( !localStorage.getItem("authToken") ) {
        state.authenticated = '';
      } else {
        state.authenticated = localStorage.getItem('authToken');
      }
      if( !localStorage.getItem("expiredTrial") ) {
        state.expiredTrial = false;
      } else {
        state.expiredTrial = (localStorage.getItem('expiredTrial') == "true");
      }
      if( !localStorage.getItem("isTrial") ) {
        state.isTrial = false;
      } else {
        state.isTrial = (localStorage.getItem('isTrial') == "true");
      }
      if( !localStorage.getItem("lastSearches") ) {
        state.lastSearches = [];
        localStorage.setItem("lastSearches", []);
      } else {
        state.lastSearches = JSON.parse(localStorage.getItem('lastSearches'));
      }

      if( !localStorage.getItem("visitedTopics") ) {
        state.visitedTopics = [];
        localStorage.setItem("visitedTopics", []);
      } else {
        state.visitedTopics = JSON.parse(localStorage.getItem('visitedTopics'));
      }
    },
    setAuthToken(state, data) {
      state.authenticated = data;
      localStorage.setItem("authToken", state.authenticated);
    },
    removeAuthToken(state) {
      state.authenticated = '';
      localStorage.removeItem("authToken");
    },
    updateShowFetchPublicationInfo(state, data) {
      state.showFetchPublicationInfo = data;
    },
    updateShowFetchProfileScreen(state, data) {
      state.showFetchProfileScreen = data;
    }
  },
  actions: {
    async fetchSearchResponseByQuery ({ commit, state }, query ) {

      // handle last searches
      if( query != '' && query != '*') {
        var idx = state.lastSearches.indexOf(query);
        if(idx > -1) {
          state.lastSearches.splice(idx,1);
        }
        state.lastSearches.push(query);
        localStorage.setItem("lastSearches", JSON.stringify(state.lastSearches));
      }

      state.error = '';
      if( state.response && state.preserveFilters ) {
        state.action = process.env.VUE_APP_SEARCH_URL +  state.response.base_urls.search_with_current_state.sem_url_action + '&q=' + query;
      } else {
        state.action = process.env.VUE_APP_SEARCH_URL + '?q=' + query;
      }

      return new Promise((resolve, reject) => {
        Vue.http.get(state.action, authHeader(state)).then(response => {
            commit('updateSearchResponse', response.data);
            resolve(response.data);
          }, error => {
            // error callback
            state.error = "Error: search call did not respond correctly";
            handleError(error, state);
            reject();
        })
      })
    },
    async fetchSearchResponse ({ commit, state } ) {
      state.error = '';

      var query_params = paramsSerializer(router.currentRoute.query);

      state.action = process.env.VUE_APP_SEARCH_URL + '?' + query_params;


      // handle last searches
      if( router.currentRoute.params && router.currentRoute.params.ls ) {
        if( router.currentRoute.query.q != '' && router.currentRoute.query.q != '*') {
          var idx = state.lastSearches.indexOf(router.currentRoute.query.q);
          if(idx > -1) {
            state.lastSearches.splice(idx,1);
          }
          state.lastSearches.push(router.currentRoute.query.q);
          localStorage.setItem("lastSearches", JSON.stringify(state.lastSearches));
        }
      }

      return new Promise((resolve, reject) => {
        Vue.http.get(state.action, authHeader(state)).then(response => {
            commit('updateSearchResponse', response.data);
            resolve(response.data);
          }, error => {
            // error callback
            state.error = "Error: search call did not respond correctly";
            handleError(error, state);
            reject();
        })
      })
    },
    async fetchSuggestions ({ commit, state }, terms ) {
      state.error = '';
      if(terms && terms.length > 500) return;
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_SUGGEST_URL + '?term=' + terms + semc, authHeader(state))
           .then(response => {
          commit('updateSuggest', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: search call did not respond correctly";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchLatestSuggestions ({state}, terms ) {
      if(terms && terms.length > 500) return;
      const promise = this.dispatch('fetchSuggestions', terms);
      this.lastPromise = promise;
      return new Promise( ( resolve, reject ) => {
        promise.then( result => {
          if ( promise == this.lastPromise ) {
            this.lastPromise = null;

            const items = []
            if (result && result.response && result.response.autocomplete
              && result.response.autocomplete.suggestions) {
                var item = result.response.autocomplete.suggestions;
                item.type = 'suggestion';
                items.push(item);
                /*
              result.response.autocomplete.suggestions.forEach((item) => {
                item.type = 'suggestion';
                items.push(item)
              }) */
            }

            if (result && result.response && result.response.prefetchedResults
              && result.response.prefetchedResults.response
              && result.response.prefetchedResults.response.docs) {
              result.response.prefetchedResults.response.docs.forEach((item) => {
                item.type = 'prefetched';
                items.push(item)
              })
            }

            resolve(items);
          }
        }, error => {
          // error callback
          state.error = "Error: search call did not respond correctly";
          handleError(error, state);
          reject();
        } );
      } );
    },
    async fetchSelectedResult ({ commit, state }, resultId ) {

      state.error = '';
      state.action = process.env.VUE_APP_SEARCH_URL + '?q=id:' + resultId;

      return new Promise((resolve, reject) => {
        Vue.http.get(state.action, authHeader(state)).then(response => {
            var result = '';
            if( response.data && response.data.response &&   response.data.response.numFound > 0 ) {
               result = response.data.response.docs[0]
            }
            commit('updateSelectedResult', result);
            resolve(response.data);
          }, error => {
            // error callback
            state.error = "Error: selected result could not be fetched";
            handleError(error, state);
            reject();
        })
      })
    },
    async fetchGraphByNode ({ commit, state }, nodeId ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_GRAPH_URL + '?expand=' + nodeId, authHeader(state))
           .then(response => {
          commit('updateGraph', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: graph query did not respond correctly";
          handleError(error, state);
          reject();
        })
      })

    },

    async expandGraphByNode ({ commit, state }, nodeId ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_GRAPH_URL + '?expand=' + nodeId, authHeader(state))
           .then(response => {


          var newGraph = {};
          newGraph.nodes = [];
          newGraph.links = [];

          for ( var i in state.pureGraph.nodes) {
            newGraph.nodes.push( Object.assign({}, state.pureGraph.nodes[i]));
          }

          for ( i in response.data.nodes) {
            if(!containsNode(newGraph.nodes, response.data.nodes[i])) {
              newGraph.nodes.push( Object.assign({}, response.data.nodes[i]));
            }
          }

          for ( i in state.pureGraph.links) {
            newGraph.links.push( Object.assign({}, state.pureGraph.links[i]));
          }

          for ( i in response.data.links) {
            if(!containsLink(newGraph.links, response.data.links[i])) {
              newGraph.links.push( Object.assign({}, response.data.links[i]));
            }
          }
          commit('updateGraph', newGraph);

          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: graph query did not respond correctly";
          handleError(error, state);
          reject();
        })
      })

    },

    async fetchGraphByQuery ({ commit, state }, param ) {
      state.error = '';
      var url = process.env.VUE_APP_GRAPH_URL;

      if( param.withFilters ) {
        url += state.response.base_urls.search_with_current_state.sem_url + '&q=' + param.query + '&rows=' + state.graphSettings.rows;
      }
      else {
        url += '?q=' + param.query + '&rows=' + + state.graphSettings.rows;
      }

      return new Promise((resolve, reject) => {
        Vue.http.get(url, authHeader(state))
           .then(response => {
          commit('updateGraph', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: graph query did not respond correctly";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchMLT ({ commit, state }, mlt ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(mlt, authHeader(state))
           .then(response => {
          commit('updateMLT', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: more like this results could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchHorizonTreemap ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/infographics/hierarchical/count/horizoneurope", authHeader(state))
           .then(response => {
          commit('updateHorizonTreemap', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: infographic for Horizon Treemap could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchHorizonCalendar ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/infographics/calendar/deadlines/horizoneurope", authHeader(state))
           .then(response => {
          commit('updateHorizonCalendar', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: infographic for Horizon Calendar could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchHorizonBubbles ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/infographics/bubbles/budget/horizoneurope", authHeader(state))
           .then(response => {
          commit('updateHorizonBubbles', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: infographic for Horizon Bubbles Chart could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async exportToPDF({ state }, param) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.VUE_APP_API_URL + "/sae/export-to-pdf", {
          "searchURL": param.searchURL,
          "numResults": param.numResults
        }, authHeaderPDFExport(state))
           .then(response => {
           let blob = new Blob([response.data],{ type:'application/pdf'});
           let link = document.createElement('a');
           link.href = window.URL.createObjectURL(blob);
           link.download = "sci-fund-search-results.pdf";
           link.click();
           resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: export to PDF did not finish correctly";
          handleError(error, state);
          reject();
        })
      })
    },
    async shareByEmail({ state }, param) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.post(process.env.VUE_APP_API_URL + "/sae/share-by-email", {
          "searchURL": param.searchURL,
          "recipientAddress": param.recipientAddress,
          "sendCopyToSelf": param.sendCopyToSelf
        }, authHeader(state))
           .then(response => {
           resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: share by email did not finish correctly";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchAccount ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/account", authHeader(state))
           .then(response => {
          commit('updateAccount', response.data);
          commit('updateExpiredTrial', response.data);
          commit('updateIsTrial', response.data);
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: account details could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchResearchProfiles ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + state.account.id + "/getAuthorProfiles", authHeader(state))
           .then(response => {
          commit('updateResearchProfiles', response.data);
          state.showFetchProfileScreen = false;
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: research profile details could not be fetched";
          state.showFetchProfileScreen = false;
          handleError(error, state);
          reject();
        })
      })
    },
    async createResearchProfile({ state }) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + state.account.id + "/createResearchProfile", authHeader(state))
           .then(response => {
          // :TODO: improve
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: research profile could not be created";
          handleError(error, state);
          reject();
        })
      })
    },
    async addSource({ state }, param ) {
      state.error = '';
      state.showFetchProfileScreen = true;
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + param.researchProfileId + "/add-source?url=" + param.url, authHeader(state))
           .then(response => {
          // :TODO: improve
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: could not fetch information from the source you have provided. Probably the source doesn't exist. Please provide a valid url for a scholar profile.";
          state.showFetchProfileScreen = false;
          state.returnToProfileCreationButton = true;
          handleError(error, state);
          reject();
        })
      })
    },
    async updatePublications({ state }, param ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + param.researchProfileId + "/select-publications?ids=" + param.ids, authHeader(state))
           .then(response => {
          // :TODO: improve
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: the selected publications could not be updated";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchPublications({ state }, param ) {
      state.error = '';
      state.showFetchPublicationInfo = true;
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + param.researchProfileId + "/publications/update", authHeader(state))
           .then(response => {
          // :TODO: improve
          state.showFetchPublicationInfo = false;
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: research profile details and its publications could not be updated";
          state.showFetchPublicationInfo = false;
          handleError(error, state);
          reject();
        })
      })
    },
    async deleteResearchProfile({ state }, param ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/research-profiles/" + param.researchProfileId + "/delete", authHeader(state))
           .then(response => {
          // :TODO: improve
          this.dispatch("fetchResearchProfiles");
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: research profile could not be deleted";
          handleError(error, state);
          reject();
        })
      })
    },
    async fetchSavedSearches ({ commit, state } ) {
      state.error = '';
      return new Promise((resolve, reject) => {
        Vue.http.get(process.env.VUE_APP_API_URL + "/saved-searches?sort=updated,desc", authHeader(state))
           .then(response => {
          commit('updateSavedSearches', response.data);
          resolve(response.data);
        }, error => {
          // error callback
          state.error = "Error: saved searches could not be fetched";
          handleError(error, state);
          reject();
        })
      })
    },
    async saveSearch ({ state }, param ) {
      state.error = '';

      return new Promise((resolve, reject) => {
        if( param.searchToSave.id && param.searchToSave.id !== '') {
          Vue.http.put(process.env.VUE_APP_API_URL + "/saved-searches", param.searchToSave,
           authHeader(state))
             .then(response => {
            this.dispatch("fetchSavedSearches");
            resolve(response.data);
          }, error => {
            // error callback
            state.error = "Error: search could not be saved";
            handleError(error, state);
            reject();
          })
        } else {
          Vue.http.post(process.env.VUE_APP_API_URL + "/saved-searches", param.searchToSave,
           authHeader(state))
             .then(response => {
            this.dispatch("fetchSavedSearches");
            resolve(response.data);
          }, error => {
            // error callback
            state.error = "Error: search could not be saved";
            handleError(error, state);
            reject();
          })
        }

      })
    },
    async deleteSearch ({ state }, param ) {
      state.error = '';
      return new Promise((resolve, reject) => {

          // delete saved search
          Vue.http.delete(process.env.VUE_APP_API_URL + "/saved-searches/" + param.searchToDelete.id,
           authHeader(state))
             .then(response => {
               this.dispatch("fetchSavedSearches");
               resolve(response.data);
          },
          error => {
            // error callback
            state.error = "Error: saved search could not be deleted";
            handleError(error, state);
            reject();
          })

      });

    },
    increasePendingRequests({ commit }) {
      commit("increasePendingRequests");
    },
    decreasePendingRequests({ commit }) {
      commit("decreasePendingRequests");
    }
  }
})

function containsNode(nodeList, n ) {
  if( !n ) return true;

  for(var x in nodeList ) {
    if( nodeList[x] && nodeList[x].id == n.id ) return true;
  }
  return false;
}

function containsLink(linkList, l ) {
  if( !l ) return true;

  for(var x in linkList ) {
    if( linkList[x] && linkList[x].sid == l.sid && linkList[x].tid == l.tid) return true;
  }
  return false;
}

function paramsSerializer(params) {
    const searchParams = new URLSearchParams();
    for (const key of Object.keys(params)) {
      const param = params[key];
      if (Array.isArray(param)) {
        for (const p of param) {
          searchParams.append(key, p);
        }
      } else {
        searchParams.append(key, param);
      }
    }
    return searchParams.toString();
}

export function handleError(error, state) {
  if(error && error.status == 401) {
    //console.log("401");
    state.authenticated = '';
    localStorage.removeItem('authToken');
    router.push({'name': 'login', 'query': { 'redirect': router.currentRoute.path }});
  }
}

export function authHeader(state) {
  if( state.authenticated )
    return {
      headers: {
        'Authorization': 'Bearer ' + state.authenticated
      }
    };
  else
    return {};
}

export function authHeaderPDFExport(state) {
  if( state.authenticated )
    return {
      responseType: 'arraybuffer',
      headers: {
        'Authorization': 'Bearer ' + state.authenticated
      }
    };
  else
    return {};
}
